
/**
 * Generate a temporary signed download url for direct download from S3
 */
export const getDownloadURL = async function({ uuid, index, doctype, multiTenant = false }) {
  const apiKey = multiTenant
    ? process.env.VUE_APP_ORIGINAL_DOCS_AWS_API_KEY
    : process.env.VUE_APP_AWS_API_KEY

  const api = await fetch(`${process.env.VUE_APP_AWS_API_BASE_URL}/process/realisation/${uuid}/files/${doctype}/${index}`, {
    method: 'GET',
    headers: {
      'x-api-key': apiKey,
    },
  })

  if (! api?.ok) {
    throw new Error('server error')
  }

  if (! api?.url) {
    throw new Error('missing url')
  }

  return api
}

/**
 * Simple upload of a file to a specified url. Used for direct upload to S3
 */
export const uploadFile = async function({ file, uuid }) {
  const response = await fetch(`${process.env.VUE_APP_AWS_API_BASE_URL}/process/realisation/${uuid}/files`, {
    method: 'PUT',
    headers: {
      'x-api-key': process.env.VUE_APP_AWS_API_KEY,
    },
    body: file,
  })

  return response
}

